import { Component, OnInit } from '@angular/core';
import { CfetBaseComponent } from '../../cfet-core/components/cfet-base.component';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-utf-unauth-page',
    templateUrl: './utf-unauth-page.component.html',
    styleUrls: ['./utf-unauth-page.component.scss'],
    standalone: false
})
export class UtfUnauthPageComponent extends CfetBaseComponent implements OnInit {

  stepOneIcon = true;
  stepOneSelected = false;
  stepOneTickIcon = false;
  stepOneDone = true;
  stepTwoIcon = true;
  stepTwoSelected = true;
  stepTwoInformationpage: boolean;
  stepTwoProfileDone: boolean;
  stepTwoDone = false;
  stepThreeIcon = false;
  openCancelModal = '';
  showCancelModal = false;
  progressTrackerStatus: any = 'registration';

  constructor(private title: Title) { super(); }

  ngOnInit() {
    this.title.setTitle(this.cfetTitles.information.utfHtmlTitle);
  }

  handleProgressTrackerEvent (event) {
    this.progressTrackerStatus = event;
  }

}
